// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The crisis card (BRAND_SPEC §11.1): --brand-invert-bg, radius 12.
 * Inversion means "help, now", so nothing else on a guest screen is ever
 * filled white. On Light reading the tokens turn it black.
 *
 * Compact since Oct 18 (Alexi: "a bit too large during chats"): a fifth to a
 * quarter shorter at 320, 390 and 1440 px than the spec's 20 px padding,
 * 20 px heading, 15.5 px lead and 56 px buttons. The words, the numbers,
 * their order, the filled first button and the colours are unchanged; every
 * button is at least 48 px tall, over the 44 px floor.
 */
.crisis-card {
  margin: 4px 0 24px;
  padding: 16px 14px 14px;
  border-radius: var(--radius-lg);
  background: var(--brand-invert-bg);
  color: var(--brand-invert-fg);
  font-size: 0.875rem;
  line-height: 1.45;
}

.crisis-card-heading {
  margin: 0 0 4px;
  font-size: 1.125rem;
  line-height: 1.25;
  font-weight: 700;
  color: var(--brand-invert-fg);
}

.crisis-card-lead {
  margin: 0 0 2px;
  font-size: 0.875rem;
  line-height: 1.4;
  color: var(--brand-invert-muted);
}

.crisis-card-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.crisis-card-list li {
  margin: 6px 0 0;
}

/* Every number is a 48 px button with an icon; 988 is the filled one. The
   number and its label sit close (16/18.4 px over 13/15.6 px), so a two-line
   button is 48 px too. */
.crisis-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  padding: 5px 12px;
  border-radius: var(--radius-md);
  border: 2px solid var(--brand-invert-fg);
  background: transparent;
  color: var(--brand-invert-fg);
  text-decoration: none;
}

.crisis-btn:hover {
  text-decoration: none;
  background: color-mix(in srgb, var(--brand-invert-fg) 7%, var(--brand-invert-bg));
}

.crisis-btn.call {
  background: var(--brand-invert-fg);
  color: var(--brand-invert-bg);
}

.crisis-btn.call:hover {
  background: color-mix(in srgb, var(--brand-invert-fg) 88%, var(--brand-invert-bg));
}

.crisis-btn-text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.crisis-btn-action {
  font-size: 1rem;
  line-height: 1.15;
  font-weight: 600;
}

.crisis-btn-service {
  font-size: 0.8125rem;
  line-height: 1.2;
  font-weight: 500;
  opacity: 0.86;
}

.crisis-btn-aside {
  flex: none;
  font-size: 0.8125rem;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  opacity: 0.86;
}

.crisis-card-person,
.crisis-card-more {
  margin: 8px 0 0;
  font-size: 0.8125rem;
  line-height: 1.35;
  color: var(--brand-invert-fg);
}

.crisis-card-more {
  color: var(--brand-invert-muted);
}

.crisis-card-person strong {
  font-weight: 700;
}

.crisis-card p a {
  color: var(--brand-invert-fg);
  text-decoration-line: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.2em;
}

.crisis-card p a:hover {
  text-decoration-thickness: 2px;
}

/* The focus ring flips to the card's ink so it shows on the inverted ground. */
.crisis-card :focus-visible {
  outline-color: var(--brand-invert-fg);
  box-shadow: 0 0 0 2px var(--brand-invert-bg);
}
`, "",{"version":3,"sources":["webpack://./src/components/CrisisResources.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;AACF;EACE,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,kCAAkC;EAClC,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;;yBAEyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,wCAAwC;EACxC,uBAAuB;EACvB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iFAAiF;AACnF;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,kFAAkF;AACpF;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,+EAA+E;AAC/E;EACE,qCAAqC;EACrC,4CAA4C;AAC9C","sourcesContent":["/*\n * The crisis card (BRAND_SPEC §11.1): --brand-invert-bg, radius 12.\n * Inversion means \"help, now\", so nothing else on a guest screen is ever\n * filled white. On Light reading the tokens turn it black.\n *\n * Compact since Oct 18 (Alexi: \"a bit too large during chats\"): a fifth to a\n * quarter shorter at 320, 390 and 1440 px than the spec's 20 px padding,\n * 20 px heading, 15.5 px lead and 56 px buttons. The words, the numbers,\n * their order, the filled first button and the colours are unchanged; every\n * button is at least 48 px tall, over the 44 px floor.\n */\n.crisis-card {\n  margin: 4px 0 24px;\n  padding: 16px 14px 14px;\n  border-radius: var(--radius-lg);\n  background: var(--brand-invert-bg);\n  color: var(--brand-invert-fg);\n  font-size: 0.875rem;\n  line-height: 1.45;\n}\n\n.crisis-card-heading {\n  margin: 0 0 4px;\n  font-size: 1.125rem;\n  line-height: 1.25;\n  font-weight: 700;\n  color: var(--brand-invert-fg);\n}\n\n.crisis-card-lead {\n  margin: 0 0 2px;\n  font-size: 0.875rem;\n  line-height: 1.4;\n  color: var(--brand-invert-muted);\n}\n\n.crisis-card-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.crisis-card-list li {\n  margin: 6px 0 0;\n}\n\n/* Every number is a 48 px button with an icon; 988 is the filled one. The\n   number and its label sit close (16/18.4 px over 13/15.6 px), so a two-line\n   button is 48 px too. */\n.crisis-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 48px;\n  padding: 5px 12px;\n  border-radius: var(--radius-md);\n  border: 2px solid var(--brand-invert-fg);\n  background: transparent;\n  color: var(--brand-invert-fg);\n  text-decoration: none;\n}\n\n.crisis-btn:hover {\n  text-decoration: none;\n  background: color-mix(in srgb, var(--brand-invert-fg) 7%, var(--brand-invert-bg));\n}\n\n.crisis-btn.call {\n  background: var(--brand-invert-fg);\n  color: var(--brand-invert-bg);\n}\n\n.crisis-btn.call:hover {\n  background: color-mix(in srgb, var(--brand-invert-fg) 88%, var(--brand-invert-bg));\n}\n\n.crisis-btn-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.crisis-btn-action {\n  font-size: 1rem;\n  line-height: 1.15;\n  font-weight: 600;\n}\n\n.crisis-btn-service {\n  font-size: 0.8125rem;\n  line-height: 1.2;\n  font-weight: 500;\n  opacity: 0.86;\n}\n\n.crisis-btn-aside {\n  flex: none;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  opacity: 0.86;\n}\n\n.crisis-card-person,\n.crisis-card-more {\n  margin: 8px 0 0;\n  font-size: 0.8125rem;\n  line-height: 1.35;\n  color: var(--brand-invert-fg);\n}\n\n.crisis-card-more {\n  color: var(--brand-invert-muted);\n}\n\n.crisis-card-person strong {\n  font-weight: 700;\n}\n\n.crisis-card p a {\n  color: var(--brand-invert-fg);\n  text-decoration-line: underline;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 0.2em;\n}\n\n.crisis-card p a:hover {\n  text-decoration-thickness: 2px;\n}\n\n/* The focus ring flips to the card's ink so it shows on the inverted ground. */\n.crisis-card :focus-visible {\n  outline-color: var(--brand-invert-fg);\n  box-shadow: 0 0 0 2px var(--brand-invert-bg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
